import React, { useState } from "react";
import { authAPI } from "../services/api";
import { formatApiError } from "../lib/errors";
import { Button, Field, FOCUS, InlineNote } from "./ds";
import { AuthHeading, AuthLayout, StatusPanel } from "./auth/AuthLayout";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { cn } from "../lib/utils";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, "Something went wrong. Please try again."));
    } finally {
      setIsLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthLayout>
        <StatusPanel icon="check" title="Check your email"
          body={`If there’s an account for ${email}, a reset link is on its way. It works for an hour.`}>
          <Button kind="secondary" block onClick={() => navigate("/login")}>Back to sign in</Button>
        </StatusPanel>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <Link to="/login" aria-label="Back to sign in"
        className={cn("-ml-1 mb-4 inline-flex h-8 w-8 items-center justify-center rounded-full text-text-secondary hover:bg-bg-surface hover:text-text-primary", FOCUS)}>
        <ChevronLeft size={22} aria-hidden="true" />
      </Link>
      <AuthHeading title="Reset your password" subtitle="Enter your email and we’ll send you a link to set a new one." />
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        {error && <InlineNote tone="error" text={error} />}
        <Field label="Email" type="email" inputMode="email" autoComplete="email" placeholder="you@example.com"
          value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Button type="submit" block loading={isLoading}>Send reset link</Button>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
